import { warn } from '@fluentui/react';
export const detailPanelGutterWidth = 32;
export const detailPanelScrollablePanelButtomPadding = 32;
export const detailPanelSharedPaddingStyle = {
    paddingLeft: detailPanelGutterWidth,
    paddingRight: detailPanelGutterWidth,
};
export const PanelStyles = (props) => {
    const { theme } = props;
    const m365Theme = theme;
    if (!m365Theme) {
        warn('Theme is undefined or null.');
    }
    return {
        main: [
            {
                boxShadow: m365Theme.effects.elevation64,
                background: m365Theme.semanticColors.panelBackground,
            },
        ],
        content: [
            detailPanelSharedPaddingStyle,
            { paddingBottom: detailPanelScrollablePanelButtomPadding },
        ],
        header: [detailPanelSharedPaddingStyle],
        footerInner: [detailPanelSharedPaddingStyle],
        closeButton: {
            color: m365Theme.semanticColors.menuIcon,
            selectors: {
                ':hover': {
                    color: m365Theme.semanticColors.menuIcon,
                },
            },
        },
    };
};
//# sourceMappingURL=panel.styles.js.map